export const THEMES = {
  darkacademia: {
    name: "Dark Academia",
    bg: "#000000",
    surface: "#111214",
    s2: "#17191C",
    border: "#222528",
    text: "#F4F4F2",
    sub: "#9FA4AA",
    mute: "#3A3E44",
    accent: "#5C6A7A",
    accentBg: "rgba(92,106,122,0.12)",
  },
  cozy: {
    name: "Cozy Pages",
    bg: "#FBF7F2",
    surface: "#FFFFFF",
    s2: "#F6EEDF",
    border: "#CBBFB3",
    text: "#2E4057",
    sub: "#7A6E66",
    mute: "#CBBFB3",
    accent: "#2E4057",
    accentBg: "rgba(46,64,87,0.08)",
  },
  rosewater: {
    name: "Happily Ever After",
    bg: "#F7F0F2",
    surface: "#FFF8FA",
    s2: "#F1E3E8",
    border: "#D9C2CB",
    text: "#4F2F3D",
    sub: "#7A5B68",
    mute: "#C8AAB7",
    accent: "#C97C95",
    accentBg: "rgba(201,124,149,0.14)",
  },
  quietmorning: {
    name: "First Edition",
    bg: "#F9F8F6",
    surface: "#FFFFFF",
    s2: "#F0EFED",
    border: "#E2E2E2",
    text: "#2C2F33",
    sub: "#5F6C7B",
    mute: "#B0B8C0",
    accent: "#7D8FA6",
    accentBg: "rgba(125,143,166,0.08)",
  },
  candlelight: {
    name: "Candlelight",
    bg: "#0E0E10",
    surface: "#1A1A1D",
    s2: "#222225",
    border: "#2E2E32",
    text: "#EDE6DC",
    sub: "#9A9490",
    mute: "#4A4A4E",
    accent: "#6B1F2A",
    accentBg: "rgba(107,31,42,0.14)",
  },
  orbital: {
    name: "Orbital",
    bg: "#0A1117",
    surface: "#121A22",
    s2: "#1B2732",
    border: "#30424F",
    text: "#EDF4F8",
    sub: "#A4B4BF",
    mute: "#5B707D",
    accent: "#6FA6C7",
    accentBg: "rgba(111,166,199,0.14)",
  },
  marginalia: {
    name: "Typewriter",
    bg: "#F3EEE7",
    surface: "#FBF7F1",
    s2: "#E3E0D4",
    border: "#CBC3B7",
    text: "#43363C",
    sub: "#6E6167",
    mute: "#B6ACA4",
    accent: "#6D765F",
    accentBg: "rgba(109,118,95,0.14)",
  },
};
